import { api } from '../../../api/Middleware';

const API_URL = process.env.REACT_APP_API_URL;
const BASE = `${API_URL}agents_flow/agents`;

const MessengerApiService = {
  /**
   * Lista TODAS as contas Messenger ativas da account do usuário (account-level).
   */
  listAccounts() {
    return api.get(`${API_URL}agents_flow/agents/messenger-accounts/`);
  },

  /**
   * Inicia OAuth Facebook Login para conectar Page ao agente.
   * Retorna `authorize_url`.
   */
  oauthStart(agentId) {
    return api.get(`${BASE}/${agentId}/messenger/oauth-start/`);
  },

  /**
   * Finaliza OAuth quando usuário tem múltiplas Pages — selection_key vem
   * no postMessage de erro com `needs_page_selection=true`.
   */
  selectPage(agentId, selectionKey, pageId) {
    return api.post(`${BASE}/${agentId}/messenger/oauth-select-page/`, {
      selection_key: selectionKey,
      page_id: pageId,
    });
  },

  /**
   * Status atual da Page Messenger vinculada (ou {connected: false}).
   */
  getStatus(agentId) {
    return api.get(`${BASE}/${agentId}/messenger/`);
  },

  /**
   * PATCH parcial — toggle bot_paused, refresh_profile.
   */
  update(agentId, data) {
    return api.patch(`${BASE}/${agentId}/messenger/`, data);
  },

  /**
   * Desconecta a Page (unsubscribe webhook + is_active=False).
   */
  disconnect(agentId) {
    return api.delete(`${BASE}/${agentId}/messenger/disconnect/`);
  },
};

export default MessengerApiService;
